import theme from '@app/theme';
import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';

const ErrorFallbackStyles = styled.div.attrs((props) => ({ className: 'app-error-boundary-fallback' }))`
    &.app-error-boundary-fallback {
        margin: 0 2.14em;
        padding: 0.71em;
        border: solid 1px ${theme.colors.poppy_red};
        display: flex;
        flex-direction: column;
        height: min-content;
        width: 100%;
        border-radius: 0.36em;
    }
`;

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <ErrorFallbackStyles>
            <h4>Something went wrong:</h4>
            <pre>{error.message}</pre>
            {/*<button onClick={resetErrorBoundary}>Try again</button>*/}
        </ErrorFallbackStyles>
    );
}

type DeErrorBoundaryProps = {
    children: any;
};

export function DeErrorBoundary({ children }: DeErrorBoundaryProps) {
    return <ReactErrorBoundary FallbackComponent={ErrorFallback}>{children}</ReactErrorBoundary>;
}
